import React, { Suspense, lazy } from 'react';
import { Link, withRouter } from "react-router-dom";
import { Login } from './login';
import { IMG_LOGO, COMPANY_NAME_FULL, GET_PARENT } from '../../common/';
import PageContext from '../../context';
import Select from 'react-select';

const ImageLoader = lazy(() => import('../../common/image-loader'));

class Header extends React.Component {
    static contextType = PageContext;
    constructor(props) {
        super(props);
        this.state = {
            headerMenu: [
                { "id": 1, "name": "Home", "naveLink": '/home' },
                { "id": 2, "name": "Donate", "naveLink": '/donate' },
                { "id": 3, "name": "Donors", "naveLink": '/donors' },
                { "id": 4, "name": "Solat Booking", "naveLink": 'https://ourmosques.commonspaces.sg/', redirect: true },
                { "id": 5, "name": "FAQ", "naveLink": '' }, /* https://www.ourmasjid.sg/faqs/ */
                { "id": 5, "name": "Korban 2022", "naveLink": 'https://korban.ourmasjid.sg/', redirect: true },
                /* { "id": 6, "name": "Contact", "naveLink": '/contact' } */
            ],
            filter: [],
            headerMenu: null,
            isHeaderMenu: false,
            isLogoVisible: false,
            logoUrl: '',
            isLoginEnable: false,
            isScrolling: false,
            toggleNav: null,
            languageCodeList: [
                { label: 'EN', value: 'EN' },
                { label: 'ML', value: 'ML', isdisabled: true }
            ]
        }

        this.navLinkRef = React.createRef();

        this.navLinkClick = this.navLinkClick.bind(this);
        this.scrollSpy = this.scrollSpy.bind(this);
        this.toggleNAV = this.toggleNAV.bind(this);
        this.onResizeHeaderReset = this.onResizeHeaderReset.bind(this);
    }

    toggleNAV() {
        this.setState({ toggleNav: !this.state.toggleNav });
    }

    navLinkClick(e, link) {
        if (link.redirect) {
            e.preventDefault()
            window.open(link.naveLink, "_blank")
            return;
        }
        this.setState({ isScrolling: true });
        let ele = e.target;
        let parent = GET_PARENT(ele, 'UL');
        let header = document.querySelector('header')?.offsetHeight;
        let pathName = ele.innerText.trim().replace(' ', '-').toUpperCase();
        let locPathName = this.props.history.location.pathname;
        let destination = document.getElementById(pathName);
        let PaymentContext = this.context.PaymentContext;
        PaymentContext.donationMethod = 'cause';

        if (destination) {
            e.preventDefault();
            PaymentContext.referrer = pathName;
            PaymentContext.scrollTo(pathName ?? 0);
        } else {
            PaymentContext.referrer = pathName;
        }
        this.onResizeHeaderReset();
        setTimeout(() => {
            this.setState({ isScrolling: false });
        }, 300);
    }

    scrollSpy(e) {
        let PaymentContext = this.context.PaymentContext;
        //if (PaymentContext.referrer) { PaymentContext.referrer = '';}
        if (!this.state.isScrolling) {
            this.setState({ isScrolling: true });
            setTimeout(() => {
                let ele = null;
                let list = [];

                this.state.headerMenu.forEach(item => {
                    let ele = document.getElementById(item.name.replace(' ', '-').toUpperCase());
                    if (ele) {
                        if ((ele.offsetTop - 280) <= document.body.scrollTop) {
                            list.push(item.name);
                        }
                    }
                });
                this.setState({ isScrolling: false });
                //console.log('list--', list);
                if (list) {
                    PaymentContext.setNavActiveInactive(list[list.length - 1]);
                }
                list = [];
            }, 500);
        }
    }

    configureHeader(headerData) {
        headerData.settings.map((data) => {
            switch (data.settingId) {
                case 1:
                    this.setState({
                        isLogoVisible: data.isVisible,
                        logoUrl: data.settingValue
                    })
                    break;
                case 2:
                    this.setState({
                        isHeaderMenu: data.isVisible,
                        headerMenu: [
                            { "id": 1, "name": "Home", "naveLink": '/home' },
                            { "id": 2, "name": "Donate", "naveLink": '/donate' },
                            { "id": 3, "name": "Donors", "naveLink": '/donors' },
                            { "id": 4, "name": "Solat Booking", "naveLink": 'https://ourmosques.commonspaces.sg/', redirect: true },
                            { "id": 5, "name": "FAQ", "naveLink": '' }, /* https://www.ourmasjid.sg/faqs/ */
                            { "id": 5, "name": "Korban 2022", "naveLink": 'https://korban.ourmasjid.sg/', redirect: true },
                            /* { "id": 6, "name": "Contact", "naveLink": '/contact' } */
                        ],
                        logoUrl: data.settingValue
                    });
                    break;
                case 3:
                    this.setState({
                        isLoginEnable: data.isVisible
                    })
                    break;
                default:
                    break;
            }
        })
    }

    onResizeHeaderReset() {
        const navbarToggler = document.querySelector('header .navbar-toggler');
        const navbarTogglerHidden = (window.getComputedStyle(navbarToggler)?.display === 'none') ?? navbarToggler.currentStyle?.display === 'none';

        if (navbarToggler && navbarTogglerHidden) {
            this.setState({ toggleNav: true });
        } else {
            this.setState({ toggleNav: false });
        }
    }

    componentDidMount() {
        const context = this.context;
        context.PaymentContext.navLinkRef = this.navLinkRef;

        const settings = context.blockDetails.filter((block) => block.blockId === 1)
        this.configureHeader(settings[0]);

        this.onResizeHeaderReset();
        document.body.addEventListener('scroll', this.scrollSpy);
        window.addEventListener('resize', this.onResizeHeaderReset);
    }

    componentDidUpdate(prevProps, prevState) {
        let PaymentContext = this.context.PaymentContext;
        if (!PaymentContext.navLinkRef) {
            PaymentContext.navLinkRef = this.navLinkRef;
        }
        if (document.querySelector('.pre-loader')) {
            PaymentContext.scrollTo(0);
        }
    }

    componentWillUnmount() {
        document.body.removeEventListener('scroll', this.scrollSpy);
        window.removeEventListener('resize', this.onResizeHeaderReset);
    }

    render() {

        return (
            <header>
                <div className="container">
                    {
                        this.state.isLogoVisible ?
                            <a href="/" /* onClick={(e) => e.preventDefault()} */ className="navbar-brand" title={COMPANY_NAME_FULL}>
                                <Suspense fallback={null}>
                                    <ImageLoader type="image" src={IMG_LOGO}></ImageLoader>
                                </Suspense>
                            </a>
                            :
                            null
                    }
                    <button className="navbar-toggler" type="button" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" onClick={this.toggleNAV}>
                        <span className={this.state.toggleNav ? "navbar-toggler-icon-close" : "navbar-toggler-icon"}></span>
                    </button>

                    <nav id="navbarSupportedContent" style={{ 'display': (this.state.toggleNav ? 'flex' : 'none') }}>
                        {
                            this.state.isHeaderMenu ?
                                <ul ref={this.navLinkRef} className="navbar-nav">
                                    {
                                        this.state.headerMenu.map((data, key) => {
                                            return (
                                                <li /* className={"nav-item " + (key === 0 ? 'active' : '')} */ key={key}>
                                                    <Link to={'/'} className="nav-link" onClick={(e) => this.navLinkClick(e, data)}> {/* data.naveLink */}
                                                        <span>{data.name.toUpperCase()}</span>
                                                    </Link>
                                                </li>
                                            );
                                        })
                                    }
                                </ul>
                                :
                                null
                        }

                        <form className='form'>
                            <Select
                                id="culture"
                                placeholder="EN"
                                isSearchable={false}
                                /* onChange={this.getCountryDialCode}
                                onFocus={this.onFocusShowSelected}
                                onBlur={this.onBlurShowSelected} */
                                className="select-form-control"
                                defaultValue={this.state.languageCode ? this.state.countryCodeList.filter((option) => option.value.split(",")[0] === this.state.languageCode) : ''}
                                options={this.state.languageCodeList}
                                isOptionDisabled={(option) => option.isdisabled}
                            />
                        </form>
                        {/* {
                            this.state.isLoginEnable ?
                                <div className="c-login">
                                    <Login></Login>
                                </div>
                                :
                                null
                        } */}
                    </nav>
                </div>
            </header>
        )
    }
}

//Header.contextType = PaymentContext;
export default withRouter(Header);